module.exports = __webpack_public_path__ + "img/choose-your-forex.ad795ba7.jpg";